module.exports = __webpack_public_path__ + "img/arrow.f18c27e.png";